"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  MeetingTeamMonitorWoman1: ['meeting-team-monitor-woman-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.750 6.011 A2.250 2.250 0 1 0 17.250 6.011 A2.250 2.250 0 1 0 12.750 6.011 Z', 'M15,9.011a3.75,3.75,0,0,1,3.75,3.75', 'M2.25,4.511V2.261a1.5,1.5,0,0,1,1.5-1.5h18a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5h-6', 'M17.25 15.761L17.25 18.761', 'M15.75 18.761L19.5 18.761', 'M.75,23.261a6.75,6.75,0,0,1,13.5,0', 'M3.377,11v1a5.9,5.9,0,0,1-.86,3.272', 'M11.624,11v1a5.9,5.9,0,0,0,.859,3.272', 'M3.388,11.215A5.483,5.483,0,0,0,7.5,9.316a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 10.886 A4.125 4.125 0 1 0 11.625 10.886 A4.125 4.125 0 1 0 3.375 10.886 Z']],
  MeetingTeamMonitor: ['meeting-team-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,9.761v-7.5a1.5,1.5,0,0,1,1.5-1.5h18a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5h-7.5', 'M15.349,23.261c-.754-.845-2.679-1.5-5.037-2.371-.718-.266-.6-2.138-.282-2.488a5.289,5.289,0,0,0,1.377-4.1c0-2.342-1.528-3.789-3.357-3.789S4.692,11.958,4.692,14.3A5.289,5.289,0,0,0,6.07,18.4c.318.35.435,2.222-.282,2.488-2.359.873-4.283,1.526-5.038,2.371', 'M14.25,11.193h1.5a.75.75,0,0,0,.75-.75v-.75l3,.75v-4.5l-3,.75v-.75a.75.75,0,0,0-.75-.75h-4.5a.75.75,0,0,0-.75.75v2.25']],
  MeetingTeamLaptop1: ['meeting-team-laptop-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,23.25a6.75,6.75,0,0,1,13.5,0', 'M3.375 10.875 A4.125 4.125 0 1 0 11.625 10.875 A4.125 4.125 0 1 0 3.375 10.875 Z', 'M9,.75H7.75a1.035,1.035,0,0,0-1,1.067V3.75', 'M21.75,12V1.817a1.035,1.035,0,0,0-1-1.067H19.5', 'M14.25,12h9a3.449,3.449,0,0,1-3,3h-6', 'M11.625 3.375 A2.625 2.625 0 1 0 16.875 3.375 A2.625 2.625 0 1 0 11.625 3.375 Z', 'M17.605,8.252a4.485,4.485,0,0,0-3.355-1.5']],
  MeetingSmartphoneHold: ['meeting-smartphone-hold', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M22.125,23.25l-3-4.5V13.5c0-2-3.8-4.139-5.25-5.25', 'M15.805,14.794,12.157,11.87a1.3,1.3,0,0,0-1.843,1.843L13.848,17.7v2.5c0,1.181,1.687,3.045,1.687,3.045', 'M5.577 5.394 A2.202 2.202 0 1 0 9.981 5.394 A2.202 2.202 0 1 0 5.577 5.394 Z', 'M10,9.162a4.512,4.512,0,0,0-5.125.479', 'M13.848,19.468a2.756,2.756,0,0,1-2.706,2.282H4.608a2.732,2.732,0,0,1-2.733-2.733V3.482A2.732,2.732,0,0,1,4.608.75h6.267a3,3,0,0,1,3,3v9.5', 'M1.875 15.75L7.875 15.75', 'M7.875,18.375a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  MeetingCameraCircle: ['meeting-camera-circle', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M1.500 12.011 A10.500 10.500 0 1 0 22.500 12.011 A10.500 10.500 0 1 0 1.500 12.011 Z', 'M18,9.011l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6A1.5,1.5,0,0,0,6,9.011v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z']],
  MeetingCameraSquare: ['meeting-camera-square', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M18,9.011l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6A1.5,1.5,0,0,0,6,9.011v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z', 'M1.500 1.511 L22.500 1.511 L22.500 22.511 L1.500 22.511 Z']],
  MeetingLaptop: ['meeting-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.249,23.261h-15a1.5,1.5,0,0,1-1.4-2.027l1.125-3a1.5,1.5,0,0,1,1.4-.973H16.124a1.5,1.5,0,0,1,1.4.973l1.125,3A1.5,1.5,0,0,1,17.249,23.261Z', 'M8.25 20.261L11.25 20.261', 'M17.25,12.761v3a1.5,1.5,0,0,1-1.5,1.5h-12a1.5,1.5,0,0,1-1.5-1.5v-7.5a1.5,1.5,0,0,1,1.5-1.5h4.5', 'M23.25,2.261l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z']],
  MeetingMonitor: ['meeting-monitor', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,2.261l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z', 'M18.75,12.761v6a1.5,1.5,0,0,1-1.5,1.5h-15a1.5,1.5,0,0,1-1.5-1.5v-9a1.5,1.5,0,0,1,1.5-1.5h6', 'M6.75 23.261L12.75 23.261', 'M9.75 20.261L9.75 23.261', 'M0.75 17.261L18.75 17.261']],
  MeetingTeamLaptop: ['meeting-team-laptop', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15.349,23.261c-.754-.845-2.679-1.5-5.037-2.371-.718-.266-.6-2.138-.282-2.488a5.289,5.289,0,0,0,1.377-4.1c0-2.342-1.528-3.789-3.357-3.789S4.692,11.958,4.692,14.3A5.289,5.289,0,0,0,6.07,18.4c.318.35.435,2.222-.282,2.488-2.359.873-4.283,1.526-5.038,2.371', 'M21.75,12.761V1.828a1.035,1.035,0,0,0-1-1.067h-13a1.035,1.035,0,0,0-1,1.067V7.511', 'M14.25,12.761h9a3.449,3.449,0,0,1-3,3h-6', 'M12.75,9.761H15a.75.75,0,0,0,.75-.75v-.75l3,.75v-4.5l-3,.75v-.75a.75.75,0,0,0-.75-.75H10.5a.75.75,0,0,0-.75.75v2.25']],
  MeetingTeamLaptopMan: ['meeting-team-laptop-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M14.248,23.261l-4.3-1.841V18.965s1.063-.429,1.063-3.068c.839,0,1.158-2.454-.009-2.454a3.224,3.224,0,0,0,.54-2.455c-.6-2.454-6.542-2.454-7.145,0-2.535-.527-.517,2.1-.517,2.455-1.2,0-1.2,2.454,0,2.454,0,2.639,1.159,3.068,1.159,3.068V21.42L.75,23.26', 'M9,.761H7.748a1.035,1.035,0,0,0-1,1.067V6.011', 'M21.75,12.761V1.828a1.035,1.035,0,0,0-1-1.067h-13a1.035,1.035,0,0,0-1,1.067l0,4.183', 'M14.25,12.761h9a3.449,3.449,0,0,1-3,3h-6', 'M14.25,9.761H15a.75.75,0,0,0,.75-.75v-.75l3,.75v-4.5l-3,.75v-.75a.75.75,0,0,0-.75-.75H10.5a.75.75,0,0,0-.75.75v1.5']],
  MeetingTeamLaptopWoman1: ['meeting-team-laptop-woman-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,23.25a6.75,6.75,0,0,1,13.5,0', 'M3.377,10.986v1a5.9,5.9,0,0,1-.86,3.272', 'M11.624,10.986v1a5.9,5.9,0,0,0,.859,3.272', 'M3.388,11.2A5.483,5.483,0,0,0,7.5,9.305a5.483,5.483,0,0,0,4.112,1.9', 'M3.375 10.875 A4.125 4.125 0 1 0 11.625 10.875 A4.125 4.125 0 1 0 3.375 10.875 Z', 'M9,.75H7.75a1.035,1.035,0,0,0-1,1.067V3.75', 'M21.75,12V1.817a1.035,1.035,0,0,0-1-1.067H19.5', 'M15.75,12h7.5a3.449,3.449,0,0,1-3,3h-4.5', 'M11.625 3.375 A2.625 2.625 0 1 0 16.875 3.375 A2.625 2.625 0 1 0 11.625 3.375 Z', 'M17.605,8.252a4.485,4.485,0,0,0-3.355-1.5']],
  MeetingTeamLaptopMan1: ['meeting-team-laptop-man-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M.75,23.25a6.75,6.75,0,0,1,13.5,0', 'M3.945,8.781a6.858,6.858,0,0,0,7.643,1.536', 'M3.375 10.875 A4.125 4.125 0 1 0 11.625 10.875 A4.125 4.125 0 1 0 3.375 10.875 Z', 'M9,.75H7.75a1.035,1.035,0,0,0-1,1.067V3.75', 'M21.75,12V1.817a1.035,1.035,0,0,0-1-1.067H19.5', 'M14.25,12h9a3.449,3.449,0,0,1-3,3h-6', 'M11.625 3.375 A2.625 2.625 0 1 0 16.875 3.375 A2.625 2.625 0 1 0 11.625 3.375 Z', 'M17.605,8.252a4.485,4.485,0,0,0-3.355-1.5']],
  MeetingTeamMonitorMan: ['meeting-team-monitor-man', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,7.511V2.261a1.5,1.5,0,0,1,1.5-1.5h18a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5h-7.5', 'M14.25,10.511h1.5a.75.75,0,0,0,.75-.75v-.75l3,.75v-4.5l-3,.75v-.75a.75.75,0,0,0-.75-.75h-4.5a.75.75,0,0,0-.75.75v1.5', 'M14.248,23.261l-4.3-1.841V18.965s1.063-.429,1.063-3.068c.839,0,1.158-2.454-.009-2.454a3.224,3.224,0,0,0,.54-2.455c-.6-2.454-6.542-2.454-7.145,0-2.535-.527-.517,2.1-.517,2.455-1.2,0-1.2,2.454,0,2.454,0,2.639,1.159,3.068,1.159,3.068V21.42L.75,23.26']],
  MeetingHeadphones: ['meeting-headphones', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.5,18.011H3.75a3,3,0,0,1-3-3v-3a3,3,0,0,1,3-3H4.5c.414,0,1.5.336,1.5.75v7.5C6,17.675,4.914,18.011,4.5,18.011Z', 'M20.25,18.011H19.5c-.414,0-1.5-.336-1.5-.75v-7.5c0-.414,1.086-.75,1.5-.75h.75a3,3,0,0,1,3,3v3A3,3,0,0,1,20.25,18.011Z', 'M3.75,9.011A8.25,8.25,0,0,1,12,.761h0a8.25,8.25,0,0,1,8.25,8.25', 'M15,21.761h2.25a3,3,0,0,0,3-3h0v-.75', 'M13.5,23.261h-3a1.5,1.5,0,0,1-1.5-1.5H9a1.5,1.5,0,0,1,1.5-1.5h3a1.5,1.5,0,0,1,1.5,1.5h0A1.5,1.5,0,0,1,13.5,23.261Z']],
  MeetingHeadphoneWireless: ['meeting-headphone-wireless', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.927,14.877v-.616a6.018,6.018,0,0,0-6-6h0a6.018,6.018,0,0,0-6,6v.616', 'M15.259,5.261a4.452,4.452,0,0,0-6.665,0', 'M18.259,3.761a8.183,8.183,0,0,0-12.665,0', 'M7.127,19.361a.9.9,0,0,1-.9.9h0a2.7,2.7,0,0,1-2.7-2.7h0a2.7,2.7,0,0,1,2.7-2.7h0a.9.9,0,0,1,.9.9Z', 'M16.727,19.361a.9.9,0,0,0,.9.9h0a2.7,2.7,0,0,0,2.7-2.7h0a2.7,2.7,0,0,0-2.7-2.7h0a.9.9,0,0,0-.9.9Z', 'M17.927,20.244a3.018,3.018,0,0,1-3.018,3.017H12.677']],
  MeetingTeamMonitorMan1: ['meeting-team-monitor-man-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.750 6.010 A2.250 2.250 0 1 0 17.250 6.010 A2.250 2.250 0 1 0 12.750 6.010 Z', 'M15,9.01a3.75,3.75,0,0,1,3.75,3.75', 'M2.25,4.51V2.26A1.5,1.5,0,0,1,3.75.76h18a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5h-7.5', 'M17.25 15.76L17.25 18.76', 'M15.75 18.76L19.5 18.76', 'M.75,23.26a6.75,6.75,0,0,1,13.5,0', 'M3.945,8.791a6.857,6.857,0,0,0,7.642,1.536', 'M3.375 10.885 A4.125 4.125 0 1 0 11.625 10.885 A4.125 4.125 0 1 0 3.375 10.885 Z']],
  MeetingSmartphoneMessage: ['meeting-smartphone-message', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.722,16.51l-.011,4.479a2.732,2.732,0,0,1-2.693,2.271H3.483A2.733,2.733,0,0,1,.75,20.528V4.993A2.734,2.734,0,0,1,3.483,2.26H9.75', 'M6.75,19.885a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0', 'M3.75,14.26h0a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3h0', 'M4.500 9.010 A2.250 2.250 0 1 0 9.000 9.010 A2.250 2.250 0 1 0 4.500 9.010 Z', 'M18,.76a5.226,5.226,0,0,0-3.937,8.69l-.657,3.779,3.423-2.11A5.246,5.246,0,1,0,18,.76Z']],
  MeetingTeamMonitorWoman: ['meeting-team-monitor-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M2.25,7.511V2.261a1.5,1.5,0,0,1,1.5-1.5h18a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5h-4.5', 'M15,10.511h.75a.75.75,0,0,0,.75-.75v-.75l3,.75v-4.5l-3,.75v-.75a.75.75,0,0,0-.75-.75h-4.5a.75.75,0,0,0-.75.75v1.5', 'M10.172,20.569a7.182,7.182,0,0,0,4.96-1.315c-.749-.75-1.265-1.221-1.462-4.129-.294-4.335-3.217-5.86-5.729-5.86s-5.435,1.525-5.729,5.86C2.015,18.033,1.5,18.5.75,19.254a7.209,7.209,0,0,0,4.988,1.315', 'M13.492,23.242c-.837-.326-1.773-.663-2.772-1.033a.882.882,0,0,1-.576-.827V19.773a.88.88,0,0,1,.287-.65,3.173,3.173,0,0,0,1.035-2.366v-2.2A5.719,5.719,0,0,1,7.941,12.56a5.716,5.716,0,0,1-3.525,1.993v2.2a3.175,3.175,0,0,0,1.035,2.366.88.88,0,0,1,.287.65v1.609a.882.882,0,0,1-.576.827c-1.018.377-1.971.72-2.82,1.052']],
  MeetingRemote: ['meeting-remote', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M15,11.261H9a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3Z', 'M9.750 6.011 A2.250 2.250 0 1 0 14.250 6.011 A2.250 2.250 0 1 0 9.750 6.011 Z', 'M3.750 0.761 L20.250 0.761 L20.250 11.261 L3.750 11.261 Z', 'M2.250 18.011 A2.250 2.250 0 1 0 6.750 18.011 A2.250 2.250 0 1 0 2.250 18.011 Z', 'M8.25,23.261a4.25,4.25,0,0,0-7.5,0', 'M17.250 18.011 A2.250 2.250 0 1 0 21.750 18.011 A2.250 2.250 0 1 0 17.250 18.011 Z', 'M23.25,23.261a4.25,4.25,0,0,0-7.5,0', 'M9.750 18.011 A2.250 2.250 0 1 0 14.250 18.011 A2.250 2.250 0 1 0 9.750 18.011 Z', 'M15.75,23.261a4.25,4.25,0,0,0-7.5,0']],
  MeetingCamera: ['meeting-camera', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M0.750 5.261 L15.750 5.261 L15.750 18.761 L0.750 18.761 Z', 'M18.75,15.011l3.415,1.707a.75.75,0,0,0,1.085-.671V7.974a.749.749,0,0,0-1.085-.67L18.75,9.011']],
  MeetingSmartphone: ['meeting-smartphone', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M23.25,2.261l-3,1v-1a1.5,1.5,0,0,0-1.5-1.5h-6a1.5,1.5,0,0,0-1.5,1.5v6a1.5,1.5,0,0,0,1.5,1.5h6a1.5,1.5,0,0,0,1.5-1.5v-1l3,1Z', 'M12.75,12.761v7.767a2.732,2.732,0,0,1-2.732,2.733H3.483A2.732,2.732,0,0,1,.75,20.528V4.993A2.732,2.732,0,0,1,3.483,2.261H8.25', 'M0.75 5.261L8.25 5.261', 'M0.75 17.261L12.75 17.261', 'M6.75,19.886a.375.375,0,1,0,.375.375.375.375,0,0,0-.375-.375h0']],
  MeetingMonitorWebcam: ['meeting-monitor-webcam', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12,2.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,2.25h0', 'M9.750 9.750 A2.250 2.250 0 1 0 14.250 9.750 A2.250 2.250 0 1 0 9.750 9.750 Z', 'M15.75,15a4.25,4.25,0,0,0-7.5,0', 'M15.75,3h6a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5H2.25a1.5,1.5,0,0,1-1.5-1.5V4.5A1.5,1.5,0,0,1,2.25,3h6', 'M15.75 22.5L8.25 22.5 9 18 15 18 15.75 22.5z', 'M6 22.5L18 22.5']],
  MeetingTeamLaptopWoman: ['meeting-team-laptop-woman', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M10.172,20.569a7.182,7.182,0,0,0,4.96-1.315c-.749-.75-1.265-1.221-1.462-4.129-.294-4.335-3.217-5.86-5.729-5.86s-5.435,1.525-5.729,5.86C2.015,18.033,1.5,18.5.75,19.254a7.209,7.209,0,0,0,4.988,1.315', 'M13.492,23.242c-.837-.326-1.773-.663-2.772-1.033a.882.882,0,0,1-.576-.827V19.773a.88.88,0,0,1,.287-.65,3.173,3.173,0,0,0,1.035-2.366v-2.2A5.719,5.719,0,0,1,7.941,12.56a5.716,5.716,0,0,1-3.525,1.993v2.2a3.175,3.175,0,0,0,1.035,2.366.88.88,0,0,1,.287.65v1.609a.882.882,0,0,1-.576.827c-1.018.377-1.971.72-2.82,1.052', 'M21.75,12.761V1.828a1.035,1.035,0,0,0-1-1.067h-13a1.035,1.035,0,0,0-1,1.067V6.761', 'M16.5,12.761h6.75a3.449,3.449,0,0,1-3,3H16.5', 'M14.25,9.761H15a.75.75,0,0,0,.75-.75v-.75l3,.75v-4.5l-3,.75v-.75a.75.75,0,0,0-.75-.75H10.5a.75.75,0,0,0-.75.75v2.25']],
  MeetingTeamMonitor1: ['meeting-team-monitor-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M12.750 6.010 A2.250 2.250 0 1 0 17.250 6.010 A2.250 2.250 0 1 0 12.750 6.010 Z', 'M15,9.01a3.75,3.75,0,0,1,3.75,3.75', 'M2.25,4.51V2.26A1.5,1.5,0,0,1,3.75.76h18a1.5,1.5,0,0,1,1.5,1.5v12a1.5,1.5,0,0,1-1.5,1.5h-7.5', 'M17.25 15.76L17.25 18.76', 'M15.75 18.76L19.5 18.76', 'M.75,23.26a6.75,6.75,0,0,1,13.5,0', 'M3.375 10.885 A4.125 4.125 0 1 0 11.625 10.885 A4.125 4.125 0 1 0 3.375 10.885 Z']],
  MeetingHeadphones1: ['meeting-headphones-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M3.046,10.061a8.931,8.931,0,1,1,17.846,0', 'M19.589,18.273a8.917,8.917,0,0,1-5.832,3.632', 'M5.775,15.85a2.266,2.266,0,0,1-.412,1.678,2.227,2.227,0,0,1-4-1L.776,12.649a2.261,2.261,0,0,1,.412-1.678,2.226,2.226,0,0,1,4,1Z', 'M18.225,15.85a2.266,2.266,0,0,0,.412,1.678,2.227,2.227,0,0,0,4-1l.586-3.879a2.261,2.261,0,0,0-.412-1.678,2.226,2.226,0,0,0-4,1Z', 'M10.109 21.386 A1.86 1.875 0 1 0 13.829 21.386 A1.86 1.875 0 1 0 10.109 21.386 Z']]
};
exports["default"] = _default;